const PoStock = () => import("./views/po-stock.vue");
import DashboardLayout from "../../../views/Layout/DashboardLayout.vue";

const moduleRoute = {
  path: "/",
  component: DashboardLayout,
  children: [
    {
      path: "/po_stock",
      component: PoStock,
      name: "PO Stock",
      meta: {
        groupName: "Reports",
      },
    },
  ],
};

export default (router) => {
  router.addRoutes([moduleRoute]);
};
